import { useState, useMemo, useEffect } from "react";
import { BattleState } from "../../State/State";
import { AnimationStep, useAnimationQueue } from "./useAnimationQueue";

export interface AnimationState {
  showDefenderSecond: boolean;
  showDefenderThird: boolean;
  showBattleAnimation: boolean;
  showStory: boolean;
  showResult: boolean;
}

export const useBattleAnimation = (battleResult: BattleState | null) => {
  const [animationStarted, setAnimationStarted] = useState(false);
  const [animationState, setAnimationState] = useState<AnimationState>({
    showDefenderSecond: false,
    showDefenderThird: false,
    showBattleAnimation: false,
    showStory: false,
    showResult: false,
  });

  const animationSteps = useMemo<AnimationStep[]>(() => {
    if (!battleResult) return [];

    return [
      {
        id: "show-defender-second",
        duration: 500,
        action: () => {
          setAnimationState((prev) => ({ ...prev, showDefenderSecond: true }));
        },
      },
      {
        id: "show-defender-third",
        duration: 500,
        action: () => {
          setAnimationState((prev) => ({ ...prev, showDefenderThird: true }));
        },
      },
      {
        id: "show-battle-animation",
        duration: 1800,
        action: () => {
          setAnimationState((prev) => ({ ...prev, showBattleAnimation: true }));
        },
      },
      {
        id: "show-story",
        duration: 2500,
        action: () => {
          setAnimationState((prev) => ({ ...prev, showStory: true }));
        },
      },
      {
        id: "show-result",
        duration: 0,
        action: () => {
          setAnimationState((prev) => ({ ...prev, showResult: true }));
          console.log("result", battleResult);
        },
      },
    ];
  }, [battleResult]);

  const animationQueue = useAnimationQueue(animationSteps);

  useEffect(() => {
    if (battleResult && !animationStarted) {
      setAnimationStarted(true);
      animationQueue.start();
    }
  }, [battleResult, animationStarted, animationQueue]);

  const resetAnimation = () => {
    setAnimationStarted(false);
    setAnimationState({
      showDefenderSecond: false,
      showDefenderThird: false,
      showBattleAnimation: false,
      showStory: false,
      showResult: false,
    });
    animationQueue.reset();
  };

  return {
    animationState,
    animationQueue,
    resetAnimation,
  };
};
